import dayjs from 'dayjs';
import GradationalSalary from './GradationalSalary.js';
import Job from './Job.js';
import SalaryIncreaseStep from './SalaryIncreaseStep.js';

export default class Department {
  constructor(data) {
    this.id = data?.id;
    this.name = data?.name;
  }
}
